import axios from "axios";

const stagingUrl =
  process.env.REACT_APP_API_URL || "https://friday.carching.co";

const header = (auth_token) => {
  return {
    "Content-Type": "application/json",
    // "Allow-Control-Allow-Origin": "*",
    Accept: "*/*",
    Accept: "application/json",
    Authorization: `Bearer ${auth_token}`
  };
};

const callApi = async (method, endpoint, params, auth_token) => {
  try {
    const response = await axios({
      method,
      headers: header(auth_token),
      url: `${stagingUrl}/api/${endpoint}`,
      data: JSON.stringify(params),
      timeout: 25000
    });
    return { response };
  } catch (error) {
    return { error };
  }
};

export const authUserWithScan = async ({ qr_code, bearerToken }) => {
  let { response, error } = await callApi(
    "post",
    "appointments/verify",
    {
      qr_code
    },
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};

export const submitCarPictures = async ({ pictures, bearerToken }) => {
  let { response, error } = await callApi(
    "post",
    "appointments/submit",
    {
      ...pictures
    },
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};
export const submitMonthlyCarPictures = async ({ pictures, bearerToken }) => {
  let { response, error } = await callApi(
    "post",
    "driver_campaigns/monthly_check/submit",
    {
      ...pictures
    },
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};
export const getStatus = async ({ bearerToken }) => {
  let { response, error } = await callApi(
    "get",
    "appointments/status",
    null,
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};

export const getCampaignTypes = async (bearerToken, id) => {
  let { response, error } = await callApi(
    "get",
    `campaign_assets/${id}/types`,
    null,
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};

export const getCampaignAssets = async (bearerToken, id, param) => {
  let { response, error } = await callApi(
    "get",
    `campaign_assets/${id}/assets?${param}`,
    null,
    bearerToken
  );

  if (response) {
    return response;
  } else {
    return error.response;
  }
};
